import { render } from "./ScreenerModal.vue?vue&type=template&id=0a6d0f3b&ts=true"
import script from "./ScreenerModal.vue?vue&type=script&lang=ts"
export * from "./ScreenerModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__